<template>
  <div>
    <div class="row">
      <div class="col-lg-4 col-md-5" v-show="tieneAlias('Teléfonos')">
        <label>{{ cargarAliasCampo('Teléfonos') }}</label>
        <table class="mb-2">
          <tr>
            <td>
              <select class="form-select" v-model="tipoTelefono">
                <option value="celular">Celular</option>
                <option value="casa">Casa</option>
                <option value="trabajo">Trabajo</option>
                <option value="otro">Otro</option>
              </select>
            </td>
            <td style="width: 80px">
              <input 
                type="text" v-model="prefijo" 
                title="Prefijo telefónico" class="form-control" 
                placeholder="+52" onkeypress="return check(event, 'telefono')">
            </td>
            <td>
              <input
                ref="numeroTelefonico"
                type="text"
                class="form-control"
                v-model="numeroTelefono"
                v-on:keyup.enter="agregarTelefono()"
                onkeypress="return check(event, 'telefono')"
                placeholder="55 1234 5678"
              />
            </td>
            <td>
              <button
                class="btn btn-success"
                @click="agregarTelefono()"
                type="button"
              >
                <i class="mdi mdi-plus"></i>
              </button>
            </td>
          </tr>
        </table>
        <div class="table-responsive" style="min-height: 120px; max-height: 200px;">
          <table id="tbl-telefonos" class="table table-hover">
            <thead>
              <tr>
                <th>Tipo</th>
                <th style="width: 80px">Prefijo</th>
                <th>Número</th>
                <th>
                  <i class="fa fa-minus"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(telefono, index) in localCliente.telefonos" :key="telefono.id">
                <td>{{ telefono.tipo }}</td>
                <td>
                  <input 
                    type="text" v-model="telefono.prefijo" class="prefijo"
                    @input="actualizarCliente()"
                    :class="modoTemplate == 'dark' ? 'text-gris' : 'text-dark'"
                  />
                </td>
                <td>
                  <input
                    type="text" v-model="telefono.numero"
                    class="telefono" :class="modoTemplate == 'dark' ? 'text-gris' : 'text-dark'"
                    onkeypress="return check(event, 'telefono')"
                    @input="actualizarCliente()"
                  />
                </td>
                <td>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="eliminarTelefono(index)"
                  >
                    <i class="mdi mdi-minus"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-lg-4 col-md-5">
        <div v-show="tieneAlias('Correo electrónico')">
          <label>{{ cargarAliasCampo('Correo electrónico') }}</label>
          <input
            type="text" class="form-control"
            v-model="localCliente.correo"
            @input="actualizarCliente()"
            placeholder="correo@empresa.com"
          />
          <br>
        </div>
        <div v-show="tieneAlias('Messenger')">
          <label for="messenger">
            {{ cargarAliasCampo('Messenger') }}
          </label>
          <div class="input-group">
            <div class="input-group-text">
              {{ localCliente.messenger != null && localCliente.messenger.substring(0,4) == 'http'? 'URL': '@' }}
            </div>
            <input
              type="text" name="messenger" class="form-control"
              v-model="localCliente.messenger" @input="actualizarCliente()"
              placeholder="Nombre de usuario o ID de Facebook Messenger"
              autocomplete="off" maxlength="250"
            />
          </div>
          <br>
        </div>
      </div>
      <br>
      <div class="col-lg-4 col-md-6">
        <div v-show="tieneAlias('URL 1')">
          <label for="url1">{{ cargarAliasCampo('URL 1') }}</label>
          <input
            type="text" name="url1" class="form-control"
            v-model="localCliente.url1"
            placeholder="URL1 personalizable"
            autocomplete="off" maxlength="500"
            @input="actualizarCliente()"
          />
          <br>
        </div>
        <div v-show="tieneAlias('URL 2')">
          <label for="url2">{{ cargarAliasCampo('URL 2') }}</label>
          <input
            type="text" name="url2" class="form-control"
            v-model="localCliente.url2"
            placeholder="URL2 personalizable"
            autocomplete="off" maxlength="500"
            @input="actualizarCliente()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CmpContacto',
  props: ["cliente", "tieneAlias", "cargarAliasCampo", "modoTemplate"],
  data() {
    return {
      localCliente: {},
      numeroTelefono: '',
      tipoTelefono: 'celular',
      prefijo: null,
    }
  },
  watch: {
    cliente: {
      deep: true,
      immediate: true,
      handler(val) {
        this.localCliente = JSON.parse(JSON.stringify(val))
      }
    }
  },
  methods: {
    actualizarCliente: function() {
      var self = this
      self.$emit("update:cliente", JSON.parse(JSON.stringify(this.localCliente)))
    },

    agregarTelefono() {
      var self = this

      if(self.numeroTelefono.length > 20){
        iu.msg.warning('El número telefónico no puedo contener más de 20 números.')
        self.$refs.numeroTelefonico.select().select()
        return
      }

      if(self.numeroTelefono.length == ''){
        iu.msg.warning('No se ha ingresado un número telefónico.')
        self.$refs.numeroTelefonico.select()
        return
      }

      if(self.prefijo == null || self.prefijo == '') {
         iu.msg.warning('No se ha ingresado un prefijo telefónico')
        self.$refs.prefijo.select()
        return
      }

      let newTelefono = {
        numero: self.numeroTelefono,
        prefijo: self.prefijo && self.prefijo.substring(0, 1) == '+'? self.prefijo : '+' + self.prefijo,
        tipo: self.tipoTelefono
      }

      self.$emit("agregar:telefono", newTelefono)
      self.numeroTelefono = ''
    },

    eliminarTelefono: function(index) {
      var self = this

      self.$emit("eliminar:telefono", index)
    },
  }
}
</script>

<style scoped>
.prefijo {
  width: 100%;
  border: none;
  background-color: transparent;
}
.telefono {
  width: 100%;
  border: none;
  background-color: transparent;
}
.text-gris {
  color: #8C9FB9;
}
</style>